import React from 'react';
import { Box, Grid } from '@mui/material';
import { useAnalytics } from '../../hooks/useAnalytics.ts';
import PerformanceMetrics from './components/PerformanceMetrics.tsx';
import OptimizationStrategies from './components/OptimizationStrategies.tsx';
import GradientText from '../../components/common/GradientText.tsx';
import HolographicBackground from '../../components/common/HolographicBackground.tsx';
import HolographicContainer from '../../components/common/HolographicContainer.tsx';

const Analytics: React.FC = () => {
  const { performanceMetrics, strategies, isLoading, error } = useAnalytics();

  if (isLoading) {
    return (
      <HolographicBackground>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
        }}>
          <GradientText variant="h5" gradient="primary">Loading...</GradientText>
        </Box>
      </HolographicBackground>
    );
  }

  if (error) {
    return (
      <HolographicBackground>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
        }}>
          <GradientText variant="h5" gradient="secondary" sx={{ color: '#ff6b6b' }}>
            Error loading analytics data
          </GradientText>
        </Box>
      </HolographicBackground>
    );
  }

  return (
    <HolographicBackground>
      <Box sx={{ p: 4 }}>
        <GradientText variant="h4" gradient="primary" sx={{ mb: 4 }}>
          Analytics & Optimization
        </GradientText>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <HolographicContainer>
              <PerformanceMetrics metrics={performanceMetrics} />
            </HolographicContainer>
          </Grid>
          <Grid item xs={12} lg={4}>
            <HolographicContainer>
              <OptimizationStrategies strategies={strategies || []} />
            </HolographicContainer>
          </Grid>
        </Grid>
      </Box>
    </HolographicBackground>
  );
};

export default Analytics; 